import {Mapper} from '@s-ui/domain'

export class FromRawFaqToFaqListValueObjectMapper extends Mapper {
  constructor({config, faqValueObjectFactory, faqsValueObjectFactory}) {
    super()
    this._config = config
    this._faqValueObjectFactory = faqValueObjectFactory
    this._faqsValueObjectFactory = faqsValueObjectFactory
  }

  map = ({faqs}) => {
    return this._faqsValueObjectFactory({
      items: faqs.map(({name: question, acceptedAnswer}) => {
        return this._faqValueObjectFactory({
          question,
          answer: acceptedAnswer.text
        })
      })
    })
  }
}
